import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { deDE, frFR } from '@mui/x-date-pickers/locales';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

interface LocalizationProviderProps {
  children: React.ReactNode;
}

export function LocalizationProvider({
  children,
}: Readonly<LocalizationProviderProps>) {
  // Get current language from i18n
  const currentLanguage = i18n.language || 'de';

  // Configure Luxon locale based on current language
  let luxonLocale = 'de-DE';
  if (currentLanguage === 'fr') {
    luxonLocale = 'fr-FR';
  } else if (currentLanguage === 'en') {
    luxonLocale = 'en-US';
  }

  // Configure MUI DatePicker locale text
  let localeText;
  if (currentLanguage === 'de') {
    localeText =
      deDE.components.MuiLocalizationProvider.defaultProps.localeText;
  } else if (currentLanguage === 'fr') {
    localeText =
      frFR.components.MuiLocalizationProvider.defaultProps.localeText;
  }

  return (
    <I18nextProvider i18n={i18n}>
      <MuiLocalizationProvider
        dateAdapter={AdapterLuxon}
        adapterLocale={luxonLocale}
        localeText={localeText}
      >
        {children}
      </MuiLocalizationProvider>
    </I18nextProvider>
  );
}
